<template>

  <div>

    <dlnkwait :wait_data="wait_data"></dlnkwait>

    <div class="position-relative z-index-2">
      <!-- Content -->

      <div class="align-items-md-center space-1 bg-primary text-center ">
        <div class="w-lg-65 mx-lg-auto">
          <!-- Info -->
          <div class="mt-5 mb-7 ">
            <h1 class="display-4 text-white mb-3">Ils oeuvrent sur le territoire</h1>
            <p class="lead text-white">Les porteurs et leur projet qui ont participé aux appels à projet du
              département.</p>
<!--            <a aria-disabled="true" href="/module/dlnkaap/candidature" role="button"-->
<!--               class="btn btn-info btn-lg disabled" style="font-size: 1.5rem;">-->
<!--              Poster votre projet-->
<!--            </a>-->
          </div>
          <!-- End Info -->
        </div>
      </div>

      <!-- End Content -->
    </div>

    <div class="d-lg-none position-absolute top-0 right-0 bottom-0 left-0 bg-img-hero"
         style="background-image: url(/themes/template/img/1920x1080/img2.jpg);"></div>


    <div class="container-fluid space-1">
      <div class="row">
        <div class="col-12 col-md-7 col-xl-8">
          <div class="pt-md-2 space-bottom-2 " style="height: 700px">
            <l-map
                ref="map"
                :zoom="zoom"
                :center="center"
                :options="mapOptions"
                style="height: 100%"
            >
              <l-tile-layer
                  :url="url"
                  :attribution="attribution"
              />
              <l-marker v-for="aap in aaps" v-if="aap.latitude != null && aap.longitude != null" :lat-lng="[aap.latitude, aap.longitude]" :key="aap.id" :icon="marker_icon">
                <l-tooltip>{{aap.projet_nom}} ({{aap.nom}})</l-tooltip>
                <l-popup>
                  <div>
                    {{aap.projet_nom}} ({{aap.nom}})
                    <p class="text-center">
                      <a class="btn btn-primary text-white"
                         :href="'/module/dlnkaap/page_vitrine_short?aap_id=' + aap.id">
                        En savoir plus
                      </a>
                    </p>
                    <p>
                      {{aap.presentation}}
                    </p>
                  </div>
                </l-popup>
                <!--                        @click="marker_click(aap.id)">-->
                <!--                <l-popup> {{ open_popup(aap.id) }}</l-popup>-->
              </l-marker>
            </l-map>
          </div>
        </div>

        <div v-if="show_detail" class="col-12 col-md-5 col-xl-4">
          <h3 class="umap-browse-title">
            <button type="button" class="btn btn-info" @click="back">
              <i class="fa fa-arrow-left" aria-hidden="true"></i>&nbsp;
              Retour
            </button>
          </h3>

          <a class="card" :href="'/module/dlnkaap/page_vitrine_short?aap_id=' + current_aap.id">
            <div class="card-img-top position-relative">

              <img class="w-50" :src="logo_structure"
                   :alt="'Visuel du projet : ' + current_aap.projet_nom">

<!--              <figure class="ie-curved-y position-absolute right-0 bottom-0 left-0 mb-n1">-->
<!--                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 1920 100.1">-->
<!--                  <path fill="#fff" d="M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z"></path>-->
<!--                </svg>-->
<!--              </figure>-->

              <div class="d-flex flex-wrap position-absolute" style="top: 10px; left: 10px;">
                <span class="badge badge-secondary">
                  <i aria-hidden="true" class="fa fa-eye mr-1"></i>{{current_aap.views}}
                </span>
              </div>
            </div>
            <div class="card-body">
              <h3>
                <p class="text-inherit">
                  {{current_aap.projet_nom}}
                </p>
              </h3>
              <p>
                {{ current_aap.presentation }}
              </p>

              <div class="text-center">
                <a class="btn btn-primary"
                   :href="'/module/dlnkaap/page_vitrine_short?aap_id=' + current_aap.id">
                  En savoir plus
                </a>
              </div>

            </div>
            <div class="card-footer py-3 border-top-2">
              <div class="row d-flex align-items-center justify-content-between">
                <div class="ml-3">
                  <p class="font-weight-bold mb-0">{{ current_aap.nom }}</p>
                </div>
  <!--              <div class="px-1">-->
  <!--                <p class="text-muted mb-0"> 14/04/2022 </p>-->
  <!--              </div>-->
              </div>
            </div>
          </a>
        </div>
        <div v-else class="col-12 col-md-5 col-xl-4">

          <div class="body" style="height: 700px; overflow: scroll">
            <h3 class="umap-browse-title">Ils oeuvrent sur le territoire</h3>

<!--            <div class="col-12 pl-0 multiselect" id="thematiques">-->
<!--              <div class="selectBox" id="select_themes" v-on:mouseup="showCheckboxes($event)">-->
<!--                <select class="custom-select">-->
<!--                  <option>Thématiques</option>-->
<!--                </select>-->
<!--                <div class="overSelect"></div>-->
<!--              </div>-->
<!--              <div class="checkboxes_multi">-->
<!--                <div v-for="tag in tags" :key="tag.id">-->
<!--                  <label :for="'tag_' + tag.id">-->
<!--                    <input type="checkbox"-->
<!--                           :id="'tag_' + tag.id" v-model="checked_thematiques" :value="tag.id"/>-->
<!--                    {{ tag.nom }}-->
<!--                  </label>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->

            <form class="input-group">
              <input type="search" class="form-control form-control-sm" placeholder="Rechercher un projet"
                     aria-label="Rechercher un projet"
                     aria-describedby="searchLabel" v-model="query">
              <div class="input-group-append">
                <div class="input-group-text" id="searchLabel">
                  <i class="fas fa-search"></i>
                </div>
              </div>
            </form>


            <div class="umap-browse-features">
              <table class="table table-sm table-striped table-hover">
                <tbody>
                <tr v-for="aap in aaps" :key="aap.id">
                  <td>
                    <i class="fas fa-search-plus" title="Centrer la carte sur cet élément" data-toggle="tooltip"
                       @click="show_aap(aap)"></i>
                  </td>
                  <td>
                    <span class="feature-title">{{ aap.projet_nom }} (<strong>{{ aap.nom }}</strong>)</span>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


</template>

<script>
import {LMap, LTileLayer, LMarker, LTooltip, LPopup} from "vue2-leaflet";

export default {
  // name: "Example",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LTooltip,
    LPopup,
  },
  data() {
    return {
      wait_data: Boolean,

      customer: Object,
      aaps: Array,
      tags: Array,
      current_aap: Object,
      logo_structure: "",
      aaps_count: Number,

      query: "",
      show_detail: Boolean,
      checked_thematiques: [],
      expanded: false,
      currentSelect: "",

      marker_icon: L.icon({
        iconUrl: "/themes/template/img/map/marker-icon-blue.png",
        iconSize: [20, 30],
        iconAnchor: [10, 30],
        popupAnchor: [0, -30],
      }),


      zoom: 11,
      initial_zoom: 11,
      center: ["48.91853", "2.11389 "],
      initial_center: ["48.91853", "2.11389 "],
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
          '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      mapOptions: {
        zoomSnap: 0.5
      },
    };
  },

  mounted() {
    this.show_detail = false
    this.aaps_count = 0
    this.logo_structure = "/modules/dlnkaap/img/socialmedia.jpg"
    this.get_data()
  },

  created: function () {
    window.addEventListener('mousedown', this.mouseDownEvent);
  },
  destroyed: function () {
    window.removeEventListener('mousedown', this.mouseDownEvent);
  },

  watch: {

    query: function (new_val, old_val) {
      if (new_val.length > 2) {
        this.wait_data = true
        this.get_aaps()
      }
    },

    checked_thematiques: function (new_val, old_val) {
      this.get_data()
    },

  },

  methods: {

    get_data: function () {
      this.wait_data = true
      this.get_aaps()
      this.get_tags()
    },

    get_tags: async function () {
      let _this = this
      let [secure_key, customer_id, api_url] = await get_token_2()
      api_url += "aap_tags.json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id
      api_url += '&status=2,3,4,5,9'

      axios.get(api_url)
          .then(function (response) {
            _this.tags = response.data
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
                // always executed
              }
          );
    },

    get_aaps: async function () {
      const _this = this;
      let [secure_key, customer_id, api_url, customer] = await get_token_2()
      api_url += "aaps.json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id
      api_url += '&no_pagination=1'
      api_url += '&public=true'
      // api_url += '&tags=' + _this.checked_thematiques
      api_url += '&archived=false'
      api_url += '&deleted=false'
      if (_this.query.length > 2) {
        api_url += '&search=' + _this.query
      }


      _this.customer = customer

      axios.get(api_url)
          .then(function (response) {
            _this.aaps = response.data.aaps
            if (typeof(response.data.logo_structure) != 'undefined' ) {
              _this.logo_structure = response.data.logo_structure
            }
            _this.aaps_count = response.data.meta.count
            _this.wait_data = false
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
              }
          );
    },

    back: function () {
      this.center = this.initial_center
      this.zoom = this.initial_zoom
      this.show_detail = false
      this.current_aap = null
    },

    show_aap: function (aap) {
      this.center = [aap.latitude, aap.longitude]
      setTimeout(() => {
        this.zoom = 15
      }, 300)
      this.show_detail = true
      this.current_aap = aap
    },

    showCheckboxes: function (event) {
      var checkboxes = event.target.parentElement.nextElementSibling;
      if (!this.expanded) {
        checkboxes.style.display = "block";
        this.expanded = true;
        this.currentSelect = event.target.parentElement.id;
      } else {
        checkboxes.style.display = "none";
        this.expanded = false;
      }
    },

    mouseDownEvent: function (event) {
      if (this.expanded) {
        var multiSelect = document.getElementById(this.currentSelect).nextElementSibling;
        if (!multiSelect.contains(event.target)) {
          //On a cliqué en dehors du select
          multiSelect.style.display = "none";
          this.expanded = false;
        }
      }
    },
  }
};
</script>
